var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrayerRoom = function SvgPrayerRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M4.598 20.6v-.217c0-.504-.19-.989-.532-1.359l-2.134-2.307a5 5 0 0 1-1.33-3.396L.6 7.227a1.627 1.627 0 0 1 3.253-.005l.017 5.206M10.6 20.6v-3.845c0-1.061-.421-2.079-1.172-2.83l-2.69-2.69a1.68 1.68 0 0 0-2.476 2.267L5.6 15.098m5.001 1.657c0-1.061.422-2.079 1.172-2.83l2.69-2.69a1.68 1.68 0 0 1 2.476 2.267L15.6 15.098m1 5.502v-.217c0-.504.19-.989.533-1.359l2.134-2.307a5 5 0 0 0 1.33-3.396l.002-6.094a1.627 1.627 0 0 0-3.253-.005l-.015 5.206M10.595 2.021V2.02m0 0c.2-.415.694-1.42 1.96-1.42 1.083 0 2.08 1.126 2.04 2.353-.028.911-.64 1.657-1.36 2.36a77 77 0 0 1-2.311 2.165.49.49 0 0 1-.655 0 76 76 0 0 1-2.312-2.164c-.72-.704-1.333-1.45-1.36-2.361C6.557 1.726 7.553.6 8.637.6c1.265 0 1.758 1.005 1.959 1.42m0 0h.001"
  })));
};
export default SvgPrayerRoom;